"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
require("cross-fetch/polyfill");
/** @ignore */
function fetchPrivate(input, init) {
    return __awaiter(this, void 0, void 0, function* () {
        const fetchOpts = init || {};
        fetchOpts.referrerPolicy = 'no-referrer';
        const fetchResult = yield fetch(input, fetchOpts);
        return fetchResult;
    });
}
exports.fetchPrivate = fetchPrivate;
//# sourceMappingURL=fetchUtil.js.map